<template lang="pug">
.c-the-home-about
  .title 關於本會
  .tile.is-ancestor
    .tile.is-parent
      .tile.is-child
        figure(:class="$style.aboutLogo")
          img(:src="profileLogo")
        div
          p.app-text.has-text-weight-medium 飛翔雙鴿代表屏東與桃園縣民團隊合作，平和向上；雙手緊握係代表全體會員之鄉誼緊密；椰葉乃屏東農業立縣的表徵之一，更象徵會務蒸蒸日上。而本會即以聯絡鄉誼，發揮互助精神，協助政府推行政令，促進社會建設，謀求共同福利為宗旨。
</template>

<script>
import profileLogo from "@/assets/images/profile_logo.png";

export default {
  name: "TheHomeAbout",
  data() {
    return {
      profileLogo
    };
  }
};
</script>

<style module lang="sass">
.about
  border: 2px solid $info
  color: $grey-dark !important

.aboutLogo
  +size(108px, 108px)
  float: left
  margin: 0 pxRem(24) pxRem(12) 0
  img
    +size(100%, 100%)
</style>
